var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:{'app_loading': _vm.loadingGui},attrs:{"id":"app","queue-router-hook":_vm.pageName}},[_c('router-view'),_c('Auth')],1)}
var staticRenderFns = []

export { render, staticRenderFns }